import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import "react-toggle/style.css"

import {
    UPDATE_FIELD_CONTRACT,
    CONTRACT_CREATE,
    CONTRACT_CREATE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.contract,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});



const mapDispatchToProps = dispatch => ({
    onSubmit: (name, symbol, contract, abiarray, decimal, imageurl, corporation, hq, corporatefoundingdate, founder, website, firstissuedate,
        marketcapitalisation, listedexchanges, blockcreationcycle, miningcompensationamount, totalsupply, agreementprotocol, whitepaperurl, type,
        display) => {
        const payload = agent.Contracts.create(name, symbol, contract, abiarray, decimal, imageurl, corporation, hq, corporatefoundingdate, founder,
            website, firstissuedate, marketcapitalisation, listedexchanges, blockcreationcycle, miningcompensationamount, totalsupply, agreementprotocol,
            whitepaperurl, type, display);
        dispatch({ type: CONTRACT_CREATE, payload })
    },
    onUnload: () =>
        dispatch({ type: CONTRACT_CREATE_UNLOADED })
});

class ContractAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            symbol: '',
            contract: '',
            abiarray: '',
            decimal: '',
            imageurl: '',
            corporation: '',
            hq: '',
            corporatefoundingdate: '',
            founder: '',
            website: '',
            firstissuedate: '',
            marketcapitalisation: '',
            listedexchanges: '',
            blockcreationcycle: '',
            miningcompensationamount: '',
            totalsupply: '',
            agreementprotocol: '',
            whitepaperurl: '',
            display: false,
            type: 'ERC20',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.handleDisplayChange = this.handleChange.bind(this, 'display')
        this.submitForm = (name, symbol, contract, abiarray, decimal, imageurl, corporation, hq, corporatefoundingdate, founder, website, firstissuedate,
            marketcapitalisation, listedexchanges, blockcreationcycle, miningcompensationamount, totalsupply, agreementprotocol, whitepaperurl, type, display) => ev => {
            ev.preventDefault();
            this.props.onSubmit(name, symbol, contract, abiarray, decimal, imageurl, corporation, hq, corporatefoundingdate, founder, website, firstissuedate,
                marketcapitalisation, listedexchanges, blockcreationcycle, miningcompensationamount, totalsupply, agreementprotocol, whitepaperurl, type, display + '');
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
                type: 'ERC20',
                display: true
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }
    render() {
        const name = this.state.name;
        const symbol = this.state.symbol;
        const contract = this.state.contract;
        const abiarray = this.state.abiarray;
        const decimal = this.state.decimal;
        const imageurl = this.state.imageurl;
        const corporation = this.state.corporation;
        const hq = this.state.hq;
        const corporatefoundingdate = this.state.corporatefoundingdate;
        const founder = this.state.founder;
        const website = this.state.website;
        const firstissuedate = this.state.firstissuedate;
        const marketcapitalisation = this.state.marketcapitalisation;
        const listedexchanges = this.state.listedexchanges;
        const blockcreationcycle = this.state.blockcreationcycle;
        const miningcompensationamount = this.state.miningcompensationamount;
        const totalsupply = this.state.totalsupply;
        const agreementprotocol = this.state.agreementprotocol;
        const whitepaperurl = this.state.whitepaperurl;
        const type = this.state.type;
        const display = this.state.display;
        const inProgress = this.props.inProgress
        return (
            <div class='pane'>
                <Link className="crumb" to="/contracts">&laquo; back to contracts</Link>
                <h1>New ERC20 Contract</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(name, symbol, contract, abiarray, decimal, imageurl, corporation, hq, corporatefoundingdate, founder,
                website, firstissuedate, marketcapitalisation, listedexchanges, blockcreationcycle, miningcompensationamount, totalsupply,
                agreementprotocol, whitepaperurl, type, display)}>
                    <fieldset className="form">
                        <strong>Contract name</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Contract name"
                                value={name}
                                onChange={this.updateState('name')} />
                        </fieldset>
                        <strong>Symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Symbol"
                                value={symbol}
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>Contract address</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Contract address"
                                value={contract}
                                onChange={this.updateState('contract')} />
                        </fieldset>

                        <strong>AbiArray</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder="AbiArray"
                                value={abiarray}
                                onChange={this.updateState('abiarray')} />
                        </fieldset>

                        <strong>Decimal</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Decimal"
                                value={decimal}
                                onChange={this.updateState('decimal')} />
                        </fieldset>

                        <strong>Token Image</strong>
                        <fieldset className="form-group">
                        <input
                                type="text"
                                placeholder="btc.png"
                                value={imageurl}
                                onChange={this.updateState('imageurl')} />
                        </fieldset>

                        <strong>Corporation</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="NA"
                                value={corporation}
                                onChange={this.updateState('corporation')} />
                        </fieldset>

                        <strong>Headquarters</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Tokyo"
                                value={hq}
                                onChange={this.updateState('hq')} />
                        </fieldset>

                        <strong>Corporate Founding Date</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="2011"
                                value={corporatefoundingdate}
                                onChange={this.updateState('corporatefoundingdate')} />
                        </fieldset>

                        <strong>Founder</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Satoshi Nakamoto"
                                value={founder}
                                onChange={this.updateState('founder')} />
                        </fieldset>

                        <strong>Website</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="www.bitcoin.com"
                                value={website}
                                onChange={this.updateState('website')} />
                        </fieldset>

                        <strong>First Issue Date</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="1/1/2011"
                                value={firstissuedate}
                                onChange={this.updateState('firstissuedate')} />
                        </fieldset>

                        <strong>Market Capitalisation</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="21B"
                                value={marketcapitalisation}
                                onChange={this.updateState('marketcapitalisation')} />
                        </fieldset>

                        <strong>Listed Exchanges</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="SPNC"
                                value={listedexchanges}
                                onChange={this.updateState('listedexchanges')} />
                        </fieldset>

                        <strong>Block Creation Cycle</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="1"
                                value={blockcreationcycle}
                                onChange={this.updateState('blockcreationcycle')} />
                        </fieldset>

                        <strong>Mining Compensation Amount</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="1"
                                value={miningcompensationamount}
                                onChange={this.updateState('miningcompensationamount')} />
                        </fieldset>

                        <strong>Total Supply</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="21M"
                                value={totalsupply}
                                onChange={this.updateState('totalsupply')} />
                        </fieldset>

                        <strong>Agreement Protocol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="blah"
                                value={agreementprotocol}
                                onChange={this.updateState('agreementprotocol')} />
                        </fieldset>

                        <strong>Whitepaper URL</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="blah"
                                value={whitepaperurl}
                                onChange={this.updateState('whitepaperurl')} />
                        </fieldset>

                        <strong>Type</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Type"
                                value={type}
                                onChange={this.updateState('type')} />
                        </fieldset>
                        <strong>Display</strong>
                        <fieldset className="form-group">
                            <Toggle id='display' defaultChecked={display} onChange={this.handleDisplayChange} />
                        </fieldset>
                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Create Contract
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractAdd);



// WEBPACK FOOTER //
// ./src/components/ContractAdd.js